import React from "react";

import { CheckForm, Flex, Typography } from "@samskip/frontend-components";
import { UseFormRegister } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";

import { CalculatePriceTranslation } from "../../constants";
import { CalculatorForm } from "../../formValues";

interface CompanySectionProps {
  isCalculating: boolean;
  isUseCompany: boolean;
  register: UseFormRegister<CalculatorForm>;
  userProfile: {
    SelectedCompany: {
      FullName: string;
    };
  };
}

const CompanySection = ({
  isCalculating,
  isUseCompany,
  register,
  userProfile,
}: CompanySectionProps) => {
  const { t } = useTranslation();

  return (
    <Flex
      className={`p-4 ${isUseCompany ? "bg-info-light" : "bg-neutral-100"}`}
      gap="small"
      vertical
    >
      <CheckForm
        disabled={isCalculating}
        fontWeight={isUseCompany ? "semibold" : "normal"}
        id="selected-company"
        label={t(CalculatePriceTranslation.USE_COMPANY)}
        {...register("UseCompany")}
      />
      {isUseCompany && (
        <Typography color="neutral-800" variant="body-s">
          <Trans
            components={{ bold: <strong /> }}
            i18nKey={CalculatePriceTranslation.SELECTED_COMPANY}
            values={{ c: userProfile.SelectedCompany.FullName }}
          />
        </Typography>
      )}
    </Flex>
  );
};

export default CompanySection;
